// const auth = JSON.parse(localStorage.getItem("user"));

export const status_list = [
  {
    value: "",
    label: "ทั้งหมด",
  },
  {
    value: "ACCEPT",
    label: "อนุญาตแล้ว",
  },
  {
    value: "PENDING",
    label: "รออนุมัติ",
  },
  {
    value: "REJECT",
    label: "ปฏิเสธ",
  },
];

export const datacolumns = [
  { name: "ลำดับ", selector: (row) => row.no },
  { name: "เลขบัตรประชาชน", selector: (row) => row.IDCard },
  { name: "ชื่อ", selector: (row) => row.Firstname },
  { name: "นามสกุล", selector: (row) => row.Lastname },
  { name: "วันเกิด", selector: (row) => row.Birthday },
  { name: "อายุ", selector: (row) => row.Age },
  { name: "เบอร์โทร", selector: (row) => row.Phonenumber },
  { name: "อีเมล", selector: (row) => row.Email },
  { name: "สถานะ", selector: (row) => row.Status },
  { name: "วันที่อนุญาต", selector: (row) => row.PermissionDate },
  { name: "ระยะเวลาเข้าถึง", selector: (row) => row.AccessPeriod },
  { name: "การกระทำ", selector: (row) => row.Action },
];

export const datacolumnsDoctor = [
  { name: "ลำดับ", selector: (row) => row.no },
  { name: "เลขบัตรประชาชน", selector: (row) => row.IDCard },
  { name: "ชื่อ", selector: (row) => row.Firstname },
  { name: "นามสกุล", selector: (row) => row.Lastname },
  { name: "วันเกิด", selector: (row) => row.Birthday },
  { name: "อายุ", selector: (row) => row.Age },
  { name: "เบอร์โทร", selector: (row) => row.Phonenumber },
  { name: "อีเมล", selector: (row) => row.Email },
  { name: "หมอ", selector: (row) => row.Doctor },
  { name: "สถานะ", selector: (row) => row.Status },
  { name: "วันที่อนุญาต", selector: (row) => row.PermissionDate },
  { name: "ระยะเวลาเข้าถึง", selector: (row) => row.AccessPeriod },
  { name: "การกระทำ", selector: (row) => row.Action },
];

export const pathItems = [
  { name: "หน้าหลัก", url: "/" },
  { name: "ค้นหาข้อมูลผู้ป่วย", url: "/search-for-patient-information" },
];

export const checkStatus = (data) => {
  const status = {
    ACCEPT: {
      text: "อนุญาตแล้ว",
      class: "text-[green]",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icon-tabler-check"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 12l5 5l10 -10" />
        </svg>
      ),
    },
    PENDING: {
      text: "รออนุมัติ",
      class: "text-[gray]",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icon-tabler-percentage-0"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
        </svg>
      ),
    },
    REJECT: {
      text: "ปฏิเสธ",
      class: "text-[red]",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icon-tabler-circle-minus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
          <path d="M9 12l6 0" />
        </svg>
      ),
    },
    DEFAULT: {
      text: "ไม่เคยขอดูผลตรวจ",
      class: "text-[gray]",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icon-tabler-circle-minus"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
          <path d="M9 12l6 0" />
        </svg>
      ),
    },
  };

  const currentStatus = status[data] || status.DEFAULT;

  return (
    <span className={`flex items-center space-x-2 ${currentStatus.class}`}>
      {currentStatus.icon}
      {currentStatus.text}
    </span>
  );
};

export const formatDate = (data) => {
  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icon-tabler-clock-hour-5"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
      <path d="M12 12l2 3" />
      <path d="M12 7v5" />
    </svg>
  );

  const text = data && data !== "" && data !== "-" ? data : "-";
  const color = data && data !== "" && data !== "-" ? "#437EDE" : "#9F9F9F";

  return (
    <span className={`flex gap-2 text-[0.75rem]`} style={{ color }}>
      {icon}
      {text}
    </span>
  );
};

export const formatTime = (data, label) => {
  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icon-tabler-clock-hour-5"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
      <path d="M12 12l2 3" />
      <path d="M12 7v5" />
    </svg>
  );

  const text =
    data && data !== "" && data !== "-" ? `${label} ${data} ` : "-";
  const color = data && data !== "" && data !== "-" ? "#F37F25" : "#9F9F9F";

  return (
    <span className="flex gap-2 text-[0.75rem]" style={{ color }}>
      {icon}
      {text}
    </span>
  );
};
